import React from 'react';
import {
  AdultsFilter, DaysFilter, DeviceTypeFilter,
  FilterContainer, LengthOfStayFilter, RoomsFilter
} from '@/features/filters/components/ChartFilters';
import { RealtimeFilterValues } from '../api/fetchRealtimeProperty';
import { RealtimeFilterOptions } from './useRealtimePropertyWithFilters';


export const usePropertyFilterControls = (
  filters: RealtimeFilterValues,
  filterOptions: RealtimeFilterOptions,
  updateFilter: (key: keyof RealtimeFilterValues, value: any) => void
): React.ReactNode => {
  return (
    <FilterContainer>
      <LengthOfStayFilter
        value={filters.length_of_stay}
        onChange={(value) => updateFilter('length_of_stay', value)}
        options={filterOptions.los}
      />
      <DeviceTypeFilter
        value={filters.device_type}
        onChange={(value) => updateFilter('device_type', value)}
      />
      <AdultsFilter
        value={filters.adults}
        onChange={(value) => updateFilter('adults', value)}
        options={filterOptions.adults}
      />
      <RoomsFilter
        value={filters.rooms}
        onChange={(value) => updateFilter('rooms', value)}
        options={filterOptions.rooms}
      />
      <DaysFilter
        value={filters.days}
        onChange={(value) => updateFilter('days', value)}
        options={filterOptions.days}
      />
    </FilterContainer>
  );
};